<div class="logo-box">
	<div class="logo-img"></div>
</div>

<div class="login-box">

	<div class="switch-menu">
		<button *ngFor="let stateButton of systemStates" mat-button class="switch-btn"
			[disabled]="stateButton.title === systemState"
			[ngClass]="{'active-system': stateButton.title === systemState}"
			(click)="switchSystem(stateButton.title)">{{stateButton.title}}</button>
	</div>

	<form #loginForm="ngForm" (ngSubmit)="onSubmit()">
		<!-- <div class="rect-box">
			<div class="rect"></div>
		</div> -->
		<mat-form-field> <input matInput placeholder="User Name" [required]="true" [(ngModel)]="userName" name="userName">
		</mat-form-field>
		<mat-form-field> <input matInput placeholder="Password" type="password" [required]="true" [(ngModel)]="password"
				name="password"> </mat-form-field>

		<ngb-alert *ngIf="authError" type="danger" [dismissible]="false">{{authError}}</ngb-alert>

		<button mat-button class="submit-btn" [disabled]="!loginForm.form.valid">Sign In</button>
	</form>


	<div class="spinner-box login-spinner-box" *ngIf="loginLoading">
		<mat-spinner class="spinner"></mat-spinner>
	</div>
</div>